import { FC } from 'react';
import { AppSelectBox } from 'components/FormElements';
import trpcApi from 'lib/trpcClient';
import useHandleTrpcMutation from 'hooks/ui/useHandleTrpcMutation';
import {
  getInvestorAccessPermissionGroupOptions,
  getInvestorPermissionsGroup,
} from 'further-ui/utils';
import {
  InvestorAccessPermissionGroupKey,
  InvestorAccessPermissionGroup,
  InvestorAccessPermission,
} from 'further-types/further-user';
import { styled, Box } from '@mui/material';
import { useHasPermissions } from 'hooks/ui/usePermissions';
import { RolePermission } from 'further-types/admin-user-role';

const Container = styled(Box)({
  marginRight: '2rem',
});

type Props = {
  copyIntoSystemEmails: boolean;
  accessPermissions: Array<InvestorAccessPermission>;
  furtherUserId: string;
  investorId: string;
  firmId: string;
};

const EditInvestorAccessGrantPermissions: FC<Props> = ({
  copyIntoSystemEmails,
  accessPermissions,
  furtherUserId,
  investorId,
  firmId,
}) => {
  const [canEdit] = useHasPermissions([RolePermission.EditInvestorAccessGrant]);

  const update = trpcApi.investorAccessGrant.update.useMutation(
    useHandleTrpcMutation()({
      successMessage: 'Permissions setting changed.',
    }),
  );

  const handleChange = async (
    accessPermissions: InvestorAccessPermissionGroupKey,
  ) => {
    update.mutate({
      investorId,
      furtherUserId,
      copyIntoSystemEmails,
      accessPermissions: InvestorAccessPermissionGroup[accessPermissions],
      firmId,
    });
  };

  const value = getInvestorPermissionsGroup(accessPermissions, true);
  const options = getInvestorAccessPermissionGroupOptions();

  return (
    <Container>
      <AppSelectBox
        data={options}
        labelKey="label"
        valueKey="value"
        value={value}
        variant="outlined"
        onChange={(event: any) => handleChange(event.target.value)}
        disabled={!canEdit}
      />
    </Container>
  );
};

export default EditInvestorAccessGrantPermissions;
